import { css } from "@emotion/css";
export const k8sIconStyles = css({
    width: 20,
    height: 20,
    fill: "currentcolor",
    display: "block",
});
